import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InstallationFeaturesStore } from '@store';
import {
  VitotrolRemoteControllerCommands,
  VitotrolRemoteControllerProperties,
} from '@vi-iot/client/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-select-vitotrol-device-modal',
  templateUrl: './select-vitotrol-device-modal.component.html',
  styleUrls: ['./select-vitotrol-device-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectVitotrolDeviceModalComponent implements OnInit, OnDestroy {
  deviceIds: string[];
  selectedOption: string;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public installationFeaturesStore: InstallationFeaturesStore,
    private dialogRef: MatDialogRef<SelectVitotrolDeviceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { currentFeatureName: string }
  ) {}

  ngOnInit(): void {
    this.installationFeaturesStore
      .selectInstallationDeviceFeature<
        VitotrolRemoteControllerProperties,
        VitotrolRemoteControllerCommands
      >(this.data.currentFeatureName)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((feature) => {
        this.deviceIds = feature.commands?.setZigbeeController?.params?.deviceId?.constraints?.enum;
      });
  }

  onHcOptionSelect(hcOption: string): void {
    this.selectedOption = hcOption;
  }

  onConfirm(): void {
    this.dialogRef.close({
      vitotrolId: String(this.selectedOption),
      confirmed: true,
    });
  }

  onCancel(): void {
    this.dialogRef.close({
      confirmed: false,
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
